import React from "react";
import { Timeline } from "antd";
import "./styles.css";

const TimelineComponent: React.FC = () => {
  return (
    <>
      <Timeline
        className="custom-timeline my-8"
        mode={"left"}
        items={[
          {
            label: "Feb, 2022",
            children: "Founded the company",
          },
          {
            label: "June, 2023",
            children: "We have served 70+ clients and companies",
          },
          {
            label: "Feb, 2024",
            children: "Started Special Scale-up phase",
          },
        ]}
      />
    </>
  );
};

export default TimelineComponent;
